
;(function (angular, _, moment) {
  'use strict'

  angular
    .module('kilo.common.services')
    .service('StatusService', StatusService)

  StatusService.$inject = []

  var allStatus = {
    invoice:
    [
      {
        status: 'draft',
        label: 'Brouillon',
        cssClass: 'nostate',
        transitionTo: ['validated']
      },
      {
        status: 'validated',
        label: "En attente d'envoi",
        action: 'Valider',
        cssClass: 'primary',
        transitionTo: ['sent', 'partly_paid']
      },
      {
        status: 'sent',
        label: 'Envoyée',
        action: 'Envoyer',
        cssClass: 'primary2',
        transitionTo: ['partly_paid', 'litigation', 'dunning']
      },
      {
        status: 'paid',
        label: 'Payée',
        cssClass: 'success',
        transitionTo: []
      },
      {
        status: 'partly_paid',
        label: 'Versement',
        action: 'Versement',
        tooltip: 'Enregistrer un versement sur',
        cssClass: 'success',
        transitionTo: ['partly_paid', 'litigation', 'dunning']
      },
      {
        status: 'litigation',
        label: 'Litige',
        action: 'Litige',
        tooltip: 'Passer en litige',
        cssClass: 'danger',
        transitionTo: ['partly_paid']
      },
      {
        status: 'dunning',
        label: 'Relance',
        cssClass: 'warning',
        transitionTo: ['partly_paid', 'litigation', 'dunning']
      }
    ],
    order:
    [
      {
        status: 'draft',
        label: 'Brouillon',
        cssClass: 'nostate',
        transitionTo: ['in_progress']
      },
      {
        status: 'in_progress',
        label: 'En cours',
        action: 'Valider',
        cssClass: 'primary',
        transitionTo: ['terminated']
      },
      {
        status: 'terminated',
        label: 'Clôturé',
        action: 'Clôturer',
        cssClass: 'success',
        transitionTo: []
      }
    ],
    quote:
    [
      {
        status: 'draft',
        label: 'Brouillon',
        cssClass: 'nostate',
        transitionTo: ['validated']
      },
      {
        status: 'validated',
        label: "En attente d'envoi",
        action: 'Valider',
        cssClass: 'primary',
        transitionTo: ['sent']
      },
      {
        status: 'sent',
        label: 'Envoyé',
        action: 'Envoyer',
        cssClass: 'primary2',
        transitionTo: ['signed', 'refused']
      },
      {
        status: 'refused',
        label: 'Refusé',
        action: 'Refuser',
        cssClass: 'danger',
        transitionTo: []
      },
      {
        status: 'signed',
        label: 'Signé',
        action: 'Signer',
        cssClass: 'success',
        transitionTo: ['deposit', 'invoiced']
      },
      {
        status: 'deposit',
        label: 'Acompte',
        action: 'Acompte',
        cssClass: 'success',
        transitionTo: []
      },
      {
        status: 'invoiced',
        label: 'Facturation',
        action: 'Facturation',
        cssClass: 'success',
        transitionTo: []
      }
    ],
    creditnote: [
      {
        status: 'draft',
        label: 'Brouillon',
        cssClass: 'nostate',
        transitionTo: ['validated']
      },
      {
        status: 'validated',
        label: "En attente d'envoi",
        action: 'Valider',
        cssClass: 'primary',
        transitionTo: ['sent']
      },
      {
        status: 'sent',
        label: 'Envoyé',
        action: 'Envoyer',
        cssClass: 'primary2',
        transitionTo: ['partly_paid']
      },
      {
        status: 'partly_paid',
        label: 'Versement',
        cssClass: 'success',
        action: 'Versement',
        tooltip: 'Enregistrer un versement sur',
        transitionTo: ['partly_paid']
      },
      {
        status: 'paid',
        label: 'Payé',
        action: 'Payer',
        cssClass: 'success',
        transitionTo: []
      }
    ]
  }

  function StatusService () {
    var self = this

    function getAllowedStatus (type, status) {
      return _.get(_.find(allStatus[type], { status: status }), 'transitionTo', [])
    }

    function getCssClass (type, status) {
      return _.get(_.find(allStatus[type], { status: status }), 'cssClass', '')
    }

    function getAction (type, status) {
      return _.get(_.find(allStatus[type], { status: status }), 'action', '')
    }

    function getLabel (type, status) {
      return _.get(_.find(allStatus[type], { status: status }), 'label')
    }

    function getTooltip (type, status) {
      return _.get(_.find(allStatus[type], { status: status }), 'tooltip', getAction(type, status))
    }

    function getStatuses (type) {
      return allStatus[type]
    }

    // Fonction qui récupère le dernier état général de la facture
    function getLastImportantStatus (history) {
      const statusWeight = {
        'litigation': 0,
        'dunning': 1,
        'sent': 2,
        'validated': 3
      }
      const uniqueStatus = uniqByKeepLast(history, it => it.status).filter((v) => { // Only keep given status
        return Object.keys(statusWeight).includes(v.status)
      })
        .sort((a, b) => { // Sort them by priority
          const aWeight = statusWeight[a.status]
          const bWeight = statusWeight[b.status]

          return aWeight < bWeight ? -1 : aWeight > bWeight ? 1 : 0
        })
      return _.get(uniqueStatus, '0.status', '') // Take most important
    }

    function uniqByKeepLast (a, key) {
      return [
        ...new Map(
          a.map(x => [key(x), x])
        ).values()
      ]
    }

    _.extend(self, {
      getAllowedStatus: getAllowedStatus,
      getLabel: getLabel,
      getAction: getAction,
      getCssClass: getCssClass,
      getStatuses: getStatuses,
      getLastImportantStatus: getLastImportantStatus,
      getTooltip: getTooltip
    })
  }
})(window.angular, window._, window.moment)
